(() => {
  if (window.edulitActionTrackingStarted || window.Shopify?.designMode) return;
  window.edulitActionTrackingStarted = true;

  const cleanUrl = (value) => {
    try {
      const url = new URL(value, window.location.href);
      return ['https:', 'http:'].includes(url.protocol) ? url.origin + url.pathname : '';
    } catch {
      return '';
    }
  };

  const consentAllowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    const consent = privacy?.currentVisitorConsent?.();
    return consent?.marketing === 'yes' && consent?.analytics === 'yes'
      && privacy.marketingAllowed?.() === true
      && privacy.analyticsProcessingAllowed?.() === true
      && privacy.saleOfDataAllowed?.() === true;
  };

  const trackAction = (event) => {
    const control = event.target?.closest?.('[data-edulit-action]');
    if (!control || event.isTrusted === false || control.disabled
      || control.getAttribute('aria-disabled') === 'true') return;
    if (event.button !== 0 && !(event.type === 'auxclick' && event.button === 1 && control.tagName === 'A')) return;

    const action = control.dataset.edulitAction;
    const format = control.dataset.edulitDocumentType || '';
    if (!['browse_manual', 'open_digital_manual', 'download_planning'].includes(action)) return;
    if (action === 'download_planning' && !['pdf', 'word'].includes(format)) return;

    const scope = control.closest('[data-edulit-product-id]');
    const productId = scope?.dataset.edulitProductId;
    const productHandle = scope?.dataset.edulitProductHandle;
    const pageLocation = cleanUrl(window.location.href);
    const targetUrl = cleanUrl(action === 'browse_manual'
      ? control.dataset.edulitTargetUrl : control.getAttribute('href'));
    if (!/^\d+$/.test(productId || '') || !productHandle || !targetUrl
      || !pageLocation.endsWith('/products/' + productHandle)) return;

    // Tracking must never interfere with opening the manual or resource.
    try {
      if (!consentAllowed() || !window.Shopify?.analytics?.publish) return;
      const published = window.Shopify.analytics.publish('edulit_action', {
        action_type: action,
        document_type: action === 'download_planning' ? format : '',
        product_id: productId,
        product_handle: productHandle,
        page_location: pageLocation,
        target_url: targetUrl,
      });
      published?.catch?.(() => {});
    } catch {
      // Shopify analytics can be unavailable without affecting the control.
    }
  };

  document.addEventListener('click', trackAction);
  document.addEventListener('auxclick', trackAction);
  if (!window.Shopify?.customerPrivacy) {
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
})();
